import { Denomination, Chain, Currency } from "database";

export const chainIds: Record<string, string> = {
    1: "Solana",
    2: "Gnosis (Binance Smartchain)", // Meaning Gnosis on binance smartchain!
    3: "Ethereum", // Meaning ETH normal wallet (or EOA - externally owned account)
};

export const chainNativeTokens: Record<string, string> = {
    1: "SOL",
    2: "BNB", // Meaning Gnosis on binance smartchain!
    3: "ETH", // Meaning ETH normal wallet (or EOA - externally owned account)
};

export const currencyIds: Record<string, string> = {
    1: "USD",
    2: "EUR",
    3: "GBP",
    4: "SGD",
    5: "CHF",
    6: "SEK",
    7: "ZAR",
    8: "AUD",
    9: "AED",
    10: "BRL",
};

export const FiatPriceTreshold: Record<Currency, number> = {
    USD: 10,
    EUR: 9,
    GBP: 8,
    ZAR: 175,
    CHF: 8,
    SGD: 13,
    SEK: 11,
    AUD: 15,
    AED: 37,
    BRL: 56,
};

export const dayFormat = "YYYY/MM/DD";
export const timeFormat = "HH:mm"; // Alternatively "h:mm:ss a" for AM/PM
export const wholeDateFormat = `${dayFormat} ${timeFormat}`;

export const EthNativeDenomination: Denomination = {
    address: "native",
    symbol: "ETH",
    decimals: 18,
    logo: "https://d33wubrfki0l68.cloudfront.net/58173cadb550aa738abf78137710ff17e364f269/006f6/static/6f05d59dc633140e4b547cb92f22e781/40129/eth-diamond-purple-white.jpg",
};

export const PolygonNativeDenomination: Denomination = {
    address: "native",
    symbol: "MATIC",
    decimals: 18,
    logo: "https://seeklogo.com/images/P/polygon-matic-logo-1DFDA3A3A8-seeklogo.com.png",
};

export const SolNativeDenomination: Denomination = {
    address: "native",
    symbol: "SOL",
    decimals: 9,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/solana/info/logo.png",
};

export const BinanceNativeDenomination: Denomination = {
    address: "native",
    symbol: "BNB",
    decimals: 8,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png",
};

export const TezosNativeDenomination: Denomination = {
    address: "native",
    symbol: "XTZ",
    decimals: 6,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/tezos/info/logo.png",
};

export const IcpNativeDenomination: Denomination = {
    address: "native",
    symbol: "ICP",
    decimals: 6,
    logo: "https://assets.coingecko.com/coins/images/14495/small/Internet_Computer_logo.png",
};

export const GnosisNativeDenomination: Denomination = {
    address: "native",
    symbol: "xDAI",
    decimals: 18,
    logo: "https://uploads-ssl.webflow.com/63692bf32544bee8b1836ea6/636a6e764bdb11a70341fab4_owl-forest.png",
};
export const ArbitrumNativeDenomination: Denomination = {
    address: "native",
    symbol: "ETH",
    decimals: 18,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png",
};

export const AvalancheNativeDenomination: Denomination = {
    address: "native",
    symbol: "AVAX",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png?1670992574",
};

export const OptimismNativeDenomination: Denomination = {
    address: "native",
    symbol: "ETH",
    decimals: 18,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/optimism/info/logo.png",
};
export const BitcoinNativeDenomination: Denomination = {
    address: "native",
    symbol: "BTC",
    decimals: 8,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoin/info/logo.png",
};
export const LitecoinNativeDenomination: Denomination = {
    address: "native",
    symbol: "LTC",
    decimals: 8,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/litecoin/info/logo.png",
};
export const BitcoinCashNativeDenomination: Denomination = {
    address: "native",
    symbol: "BCH",
    decimals: 8,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoincash/info/logo.png",
};

export const CardanoNativeDenomination: Denomination = {
    address: "native",
    symbol: "ADA",
    decimals: 6,
    logo: "https://assets.coingecko.com/coins/images/975/small/cardano.png?1547034860",
};

export const XrpNativeDenomination: Denomination = {
    address: "native",
    symbol: "XRP",
    decimals: 6,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ripple/info/logo.png",
};

export const FantomNativeDenomination: Denomination = {
    address: "native",
    symbol: "FTM",
    decimals: 18,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/fantom/info/logo.png",
};

export const EcreditsNativeDenomination: Denomination = {
    address: "native",
    symbol: "ECS",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/27575/small/ecs_1000x1000.png?1664685323",
};

export const StellarNativeDenomination: Denomination = {
    address: "native",
    symbol: "XLM",
    decimals: 6,
    logo: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/stellar/info/logo.png",
};

export const VaraNativeDenomination: Denomination = {
    address: "native",
    symbol: "VARA",
    decimals: 12,
    logo: "https://assets.coingecko.com/coins/images/31458/standard/vara.jpeg?1696530272",
};

export const EURDenomination: Denomination = {
    address: "native",
    symbol: "SOL",
    decimals: 9,
    logo: "https://cryptologos.cc/logos/solana-sol-logo.png",
};

export const SepoliaNativeDenomination: Denomination = {
    address: "native",
    symbol: "ETH",
    decimals: 18,
    logo: "https://d33wubrfki0l68.cloudfront.net/58173cadb550aa738abf78137710ff17e364f269/006f6/static/6f05d59dc633140e4b547cb92f22e781/40129/eth-diamond-purple-white.jpg",
};

export const RoninNativeDenomination: Denomination = {
    address: "native",
    symbol: "RON",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/20009/standard/Ronin_Mark_Blue.png?1707125056",
};

export const TronNativeDenomination: Denomination = {
    address: "native",
    symbol: "TRX",
    decimals: 6,
    logo: "https://static.tronscan.org/production/logo/trx.png",
};
export const MoonriverNativeDenomination: Denomination = {
    address: "native",
    symbol: "MOVR",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/17984/standard/9285.png?1696517502",
};
export const CosmosNativeDenomination: Denomination = {
    address: "native",
    symbol: "ATOM",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/1481/standard/cosmos_hub.png?1696502525",
};

export const AptosNativeDenomination: Denomination = {
    address: "native",
    symbol: "APT",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/26455/standard/aptos_round.png?1696525528",
};

export const CasperNativeDenomination: Denomination = {
    address: "native",
    symbol: "CSPR",
    decimals: 18,
    logo: "https://assets-currency.kucoin.com/65a7a1dc2738b90001354d8c_CSPR%20logo.png",
};

export const ProvenanceNativeDenomination: Denomination = {
    address: "native",
    symbol: "HASH",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/25321/standard/hash.png?1696524456",
};

export const OsmosisNativeDenomination: Denomination = {
    address: "native",
    symbol: "OSMO",
    decimals: 6,
    logo: "https://assets.coingecko.com/coins/images/16724/standard/osmo.png?1696516298",
};
export const InjectiveNativeDenomination: Denomination = {
    address: "native",
    symbol: "INJ",
    decimals: 18,
    logo: "https://assets.coingecko.com/coins/images/12882/standard/Secondary_Symbol.png?16965126701",
};

export const BaseNativeDenomination: Denomination = {
    address: "native",
    symbol: "ETH",
    decimals: 18,
    logo: "https://d33wubrfki0l68.cloudfront.net/58173cadb550aa738abf78137710ff17e364f269/006f6/static/6f05d59dc633140e4b547cb92f22e781/40129/eth-diamond-purple-white.jpg",
};

export const ChainToNameMap: Record<Chain, string> = {
    [Chain.ETHEREUM]: "Ethereum",
    [Chain.POLYGON]: "Polygon",
    [Chain.BINANCE]: "Binance",
    [Chain.TEZOS]: "Tezos",
    [Chain.SOLANA]: "Solana",
    [Chain.ICP]: "ICP",
    [Chain.GNOSIS]: "Gnosis Chain",
    [Chain.ARBITRUM]: "Arbitrum",
    [Chain.AVALANCHE]: "Avalanche",
    [Chain.OPTIMISM]: "Optimism",
    [Chain.BITCOIN]: "Bitcoin",
    [Chain.LITECOIN]: "Litecoin",
    [Chain.BITCOIN_CASH]: "Bitcoin Cash",
    [Chain.CARDANO]: "Cardano",
    [Chain.XRP]: "XRPL",
    [Chain.FANTOM]: "Fantom",
    [Chain.ECREDITS]: "Ecredits",
    [Chain.STELLAR]: "Stellar",
    [Chain.VARA]: "Vara",
    [Chain.SEPOLIA]: "Sepolia",
    [Chain.RONIN]: "Ronin",
    [Chain.TRON]: "Tron",
    [Chain.MOONRIVER]: "Moonriver",
    [Chain.COSMOS]: "Cosmos",
    [Chain.APTOS]: "Aptos",
    [Chain.CASPER]: "Casper",
    [Chain.PROVENANCE]: "Provenance",
    [Chain.OSMOSIS]: "Osmosis",
    [Chain.INJECTIVE]: "Injective",
    [Chain.BASE]: "Base",
};

export const PAGE_SIZE = 10;

export const MAX_AMOUNT_OF_TXS_FOR_SELF_UPDATE = 100000;

export const CONST_ADDRESSES = {
    FEE_RECEIVER: "FEE_RECEIVER",
    YIELD_EARNING: "YIELD_EARNING",
};

export const APP_NAME = "Request Accounting";
